import { render, staticRenderFns } from "./shareRecords.vue?vue&type=template&id=848898b2&scoped=true&"
import script from "./shareRecords.vue?vue&type=script&lang=js&"
export * from "./shareRecords.vue?vue&type=script&lang=js&"
import style0 from "./shareRecords.vue?vue&type=style&index=0&id=848898b2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848898b2",
  null
  
)

export default component.exports